export default __webpack_public_path__ + "static/media/img_3.98c42a1c.jpeg";